import React, { useEffect, useState } from "react";
import { getPassport, getProfile, getUsernameAndUrl } from "../api";
import Profile from "../components/Profile";
import { useRecoilState } from "recoil";
import { AtomCurrentProfileName } from "../components/atom/AtomCurrentProfileName";
import { AtomUsersUrl } from "../components/atom/AtomUsersUrl";
import { AtomUsername } from "../components/atom/AtomUsername";
import { AtomWork } from "../components/atom/AtomWork";
import { AtomDescription } from "../components/atom/AtomDescription";
import { AtomUserid } from "../components/atom/AtomUserid";
import { AtomLevel } from "../components/atom/AtomLevel";
import { AtomBirthdayDisplay } from "../components/atom/AtomBirthdayDisplay";
import { AtomCurrentFontName } from "../components/atom/AtomCurrentFontName";
import { AtomColor } from "../components/atom/AtomColor";
import { AtomBalanceRP } from "../components/atom/AtomBalanceRP";
import { AtomCurrentProfileUrl } from "../components/atom/AtomCurrentProfileUrl";
import { AtomCurrentProfileAvailable } from "../components/atom/AtomCurrentProfileAvailable";
import { AtomCurrentBadgeAvailable } from "../components/atom/AtomCurrentBadgeAvailable";
import { AtomCurrentBgName } from "../components/atom/AtomCurrentBgName";
import { AtomCurrentBgAvailable } from "../components/atom/AtomCurrentBgAvailable";
import { AtomCurrentBadge1Name } from "../components/atom/AtomCurrentBadge1Name";
import { AtomCurrentBadge1Url } from "../components/atom/AtomCurrentBadge1Url";
import { AtomCurrentBadge2Name } from "../components/atom/AtomCurrentBadge2Name";
import { AtomCurrentBadge2Url } from "../components/atom/AtomCurrentBadge2Url";
import { AtomCurrentBadge3Name } from "../components/atom/AtomCurrentBadge3Name";
import { AtomCurrentBadge3Url } from "../components/atom/AtomCurrentBadge3Url";
import { AtomCurrentBadge4Name } from "../components/atom/AtomCurrentBadgeName";
import { AtomCurrentBadge4Url } from "../components/atom/AtomCurrentBadge4Url";
import { AtomCurrentBgUrl } from "../components/atom/AtomCurrentBgUrl";
import Form from "../components/Form";
import { AtomCurrentFontAvailable } from "../components/atom/AtomCurrentFontAvailable";

const LoginPanel = () => (
  <div className="min-h-[70vh] flex items-center justify-center px-4">
    <div className="glass p-10 sm:p-14 text-center max-w-md w-full relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-52 h-52 rounded-full glow-red blur-2xl" />
      <h1 className="font-Bebas text-4xl sm:text-5xl text-white mb-4 tracking-wide">
        YOUR PROFILE AWAITS
      </h1>
      <p className="font-poppins text-white/55 text-sm sm:text-base mb-8">
        Log in with Discord to customize your profile card, badges,
        backgrounds and more.
      </p>
      <a
        href="/auth/discord"
        className="inline-block px-8 py-4 rounded-full bg-reored text-white font-poppins font-semibold shadow-[0_0_40px_rgba(213,60,53,0.45)] hover:shadow-[0_0_60px_rgba(213,60,53,0.7)] transition-shadow duration-300"
      >
        Login with Discord
      </a>
    </div>
  </div>
);

const UserDetails = () => {
  const [authState, setAuthState] = useState("loading"); // loading | in | out
  const [currentprofilename, setcurrentprofilename] = useRecoilState(AtomCurrentProfileName);
  const [usersprofile, setusersprofile] = useRecoilState(AtomUsersUrl);
  const [usersname, setusersname] = useRecoilState(AtomUsername);
  const [work, setwork] = useRecoilState(AtomWork);
  const [Description, setDescription] = useRecoilState(AtomDescription);
  const [userid, setuserid] = useRecoilState(AtomUserid);
  const [level, setlevel] = useRecoilState(AtomLevel);
  const [birthdayDisplay, setbirthdayDisplay] = useRecoilState(AtomBirthdayDisplay);
  const [font, setfont] = useRecoilState(AtomCurrentFontName);
  const [color, setcolor] = useRecoilState(AtomColor);
  const [currentFont, setcurrentFont] = useRecoilState(AtomCurrentFontName);
  const [AllFontsAvailable, setAllFontsAvailable] = useRecoilState(AtomCurrentFontAvailable)
  const [BalanceRp, setBalanceRp] = useRecoilState(AtomBalanceRP);
  const [ProfileimageUrl, setProfileimageurl] = useRecoilState(AtomCurrentProfileUrl);
  const [AllProfileAvailable, setAllProfileAvailable] = useRecoilState(AtomCurrentProfileAvailable);
  const [AllBadgesAvailable, setAllBadgesAvailable] = useRecoilState(AtomCurrentBadgeAvailable);
  const [CurrentBackgroundName, setCurrentBackgroundName] = useRecoilState(AtomCurrentBgName);
  const [CurrentBackgroundUrl, setCurrentBackgroundUrl] = useRecoilState(AtomCurrentBgUrl);
  const [AllBgAvailable, setAllBgAvailable] = useRecoilState(AtomCurrentBgAvailable);
  const [Badge1Name, setBadge1Name] = useRecoilState(AtomCurrentBadge1Name);
  const [Badge1Url, setBadge1Url] = useRecoilState(AtomCurrentBadge1Url);
  const [Badge2Name, setBadge2Name] = useRecoilState(AtomCurrentBadge2Name);
  const [Badge2Url, setBadge2Url] = useRecoilState(AtomCurrentBadge2Url);
  const [Badge3Name, setBadge3Name] = useRecoilState(AtomCurrentBadge3Name);
  const [Badge3Url, setBadge3Url] = useRecoilState(AtomCurrentBadge3Url);
  const [Badge4Name, setBadge4Name] = useRecoilState(AtomCurrentBadge4Name);
  const [Badge4Url, setBadge4Url] = useRecoilState(AtomCurrentBadge4Url);

  useEffect(() => {
    (async () => {
      try {
        getPassport().then((pass) => {
          if (!pass || !pass.user || pass.user.id === "NOPASS") {
            setAuthState("out");
            return;
          }
          setAuthState("in");
          getUsernameAndUrl(pass.user.id).then((data) => {
            setusersprofile(data.displayAvatarURL);
            setusersname(data.tag);
          });
          getProfile(pass.user.id).then((data) => {
            if (!data || data.error) return;
            setcurrentprofilename(data.curprofile);
            setwork(data.work);
            setDescription(data.description);
            setuserid(data.userid);
            setlevel(data.level);
            setbirthdayDisplay(data.birthday);
            setAllFontsAvailable(data.font);
            setcolor(data.color);
            setfont(data.curFont);
            setBalanceRp(data.balancerp);
            setAllProfileAvailable(data.profile);
            setAllBadgesAvailable(data.badges);
            setCurrentBackgroundName(data.curprofilebg);
            setAllBgAvailable(data.banner);
            const badgesObj = require("../badges.json");
            badgesObj.forEach((d) => {
              if (d.tag == data.curbadges[0]) {
                setBadge1Name(d.tag);
                setBadge1Url(d.url);
              }
            });
            badgesObj.forEach((d) => {
              if (d.tag == data.curbadges[1]) {
                setBadge2Name(d.tag);
                setBadge2Url(d.url);
              }
            });
            badgesObj.forEach((d) => {
              if (d.tag == data.curbadges[2]) {
                setBadge3Name(d.tag);
                setBadge3Url(d.url);
              }
            });
            badgesObj.forEach((d) => {
              if (d.tag == data.curbadges[3]) {
                setBadge4Name(d.tag);
                setBadge4Url(d.url);
              }
            });
            const obj = require("../profileimg.json");
            obj.forEach((d) => {
              if (d.tag == data.curprofile) {
                setProfileimageurl(d.url);
                setcurrentprofilename(d.tag);
              }
            });

            const bgobj = require("../BackgroundImage.json");
            bgobj.forEach((d) => {
              if (d.tag == data.curprofilebg) {
                setCurrentBackgroundName(d.tag);
                setCurrentBackgroundUrl(d.url);
              }
            });
          });
        })

      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  if (authState === "loading") {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-2 border-reored border-t-transparent animate-spin" />
      </div>
    );
  }

  if (authState === "out") {
    return <LoginPanel />;
  }

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <div className="max-w-7xl mx-auto">
        <h1 className="font-Bebas display-section text-white mb-2">
          CUSTOMIZE <span className="text-gradient">YOUR CARD</span>
        </h1>
        <p className="font-poppins text-white/50 text-sm sm:text-base mb-10 max-w-2xl">
          Everything you change here shows up on your /profile card in Discord
          — live preview on the left, controls on the right.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div className="w-full lg:sticky lg:top-28">
            <Profile />
          </div>
          <div className="w-full">
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
